import { makeStyles, createStyles } from '@material-ui/core'

const ANSWER_WIDTH_M = 120
const ANSWER_WIDTH_D = 160
const REF_IMG_M = 120
const REF_IMG_D = 210
const INPUT_WIDTH = 342

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: theme.extraColors.greyLight,
      padding: theme.spacing(8, 0, 9),
      minHeight: '70vh',
    },
    center: {
      textAlign: 'center',
    },
    container: {},
    content: {
      minHeight: '50vh',
      margin: 'auto',
      padding: theme.spacing(2),
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.common.white,
      [theme.breakpoints.up('lg')]: {
        maxWidth: 1035,
        padding: theme.spacing(4, 4, 2),
      },
    },
    takeBackHeaderContent: {
      marginBottom: theme.spacing(2),
    },
    takeBackHeaderTitle: {
      color: theme.palette.primary.main,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.h3.fontSize,
      },
    },
    takeBackHeaderText: {
      color: theme.extraColors.greyMedium,
      '&>p': {
        '&>a': {
          color: theme.extraColors.greyMedium,
          textDecoration: 'underline',
        },
      },
    },
    backLink: {
      color: theme.extraColors.greyText,
      marginBottom: theme.spacing(2),
      display: 'inline-flex',
      alignItems: 'center',
      padding: 0,
      textTransform: 'inherit',
      fontSize: '90%',
      '&:hover, &:focus': {
        background: 'none',
        color: theme.palette.common.black,
      },
    },
    backArrow: {
      fontSize: '1rem',
      marginRight: theme.spacing(1),
    },
    takeBackBoxContainer: {
      minHeight: 200,
      gap: theme.spacing(2),
    },
    takebackNav: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(2),
      listStyle: 'none',
      padding: 0,
      whiteSpace: 'nowrap',
      '&>li': {
        display: 'inline-flex',
        alignItems: 'center',
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(4),
        fontSize: '75%',
      },
      [theme.breakpoints.up('md')]: {
        maxWidth: '75%',
        margin: theme.spacing(0, 'auto', 5),
        position: 'relative',
        fontSize: theme.typography.body1.fontSize,
        '&:after': {
          content: '""',
          display: 'block',
          height: 1,
          position: 'absolute',
          transform: 'translateY(-50%)',
          top: '50%',
          left: theme.spacing(1),
          right: theme.spacing(1),
          background: theme.extraColors.greyMedium,
        },
      },
    },
    separator: {
      display: 'none',
    },
    stepNumber: {
      display: 'inline-flex',
      justifyContent: 'center',
      textAlign: 'center',
      alignItems: 'center',
      width: '2.5ch',
      height: '2.5ch',
      letterSpacing: 0,
      minWidth: 20,
      minHeight: 20,
      padding: 0,
      margin: theme.spacing(0.5),
      borderRadius: '50%',
      lineHeight: 1,
      fontWeight: 700,
      background: theme.extraColors.greyText,
      color: theme.palette.common.white,
    },
    listItem: {
      position: 'relative',
      [theme.breakpoints.up('md')]: {
        position: 'relative',
        zIndex: 1,
        padding: theme.spacing(0, 1),
        background: theme.palette.common.white,
      },
    },
    active: {
      '&>b': {
        backgroundColor: theme.palette.common.black,
      },
    },
    faqSection: {
      margin: theme.spacing(5, 0),
      [theme.breakpoints.up('lg')]: {
        margin: theme.spacing(5, 0),
      },
    },
    faqTitle: {
      marginBottom: theme.spacing(2),
    },
    faqList: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
    firstStepTextRequired: {
      fontSize: theme.typography.h6.fontSize,
      color: theme.extraColors.greyMedium,
    },
    firstStepFirstPartContainer: {
      margin: 'auto',
      gap: theme.spacing(2),
      maxWidth: theme.breakpoints.width('md'),
      [theme.breakpoints.up('lg')]: {},
    },
    preliminaryQuestionTitle: {},
    preliminaryQuestion: {
      [theme.breakpoints.down('md')]: {},
    },
    preliminaryQuestionCol: {
      flex: 1,
    },
    preliminaryQuestionText: {
      '& .paragraph-class': {
        margin: 0,
        display: 'inline',
      },
    },
    preliminaryQuestionRequired: {},
    preliminaryQuestionAnswer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      flex: `0 0 ${ANSWER_WIDTH_D}px`,
      [theme.breakpoints.down('md')]: {
        flex: `0 0 ${ANSWER_WIDTH_M}px`,
      },
      '& .MuiFormControlLabel-root': {
        margin: 0,
      },
      '& .MuiFormGroup-root': {
        gap: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
          gap: theme.spacing(1),
        },
      },
      '& .MuiRadio-root': {
        padding: theme.spacing(0, 0.25),
      },
    },
    error: {
      display: 'flex',
      alignItems: 'center',
      borderRadius: theme.shape.borderRadius,
      background: theme.palette.error.main,
      color: theme.palette.common.white,
      '&>svg': {
        marginRight: theme.spacing(3),
      },
      '& p': {
        marginTop: 0,
        marginBottom: theme.spacing(2),
        '&:last-child': {
          marginBottom: 0,
        },
      },
    },
    preliminaryQuestionsError: {
      display: 'block',
      padding: theme.spacing(2),
      margin: theme.spacing(4, 0),
    },
    buttonNextPart: {},
    layoutFirstStepSecondPart: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(4),
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        gap: theme.spacing(3),
      },
    },
    layoutFirstStepSecondPartPending: {
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: INPUT_WIDTH,
    },
    // test other arrangements
    firstPartContainer: {
      display: 'flex',
      gap: theme.spacing(18),
      justifyContent: 'space-between',
      [theme.breakpoints.down('md')]: {
        //flexDirection: 'column-reverse',
        gap: theme.spacing(8),
        display: 'block',
      },
    },
    referenceContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      [theme.breakpoints.down('xs')]: {
        minWidth: '100%',
      },
    },
    searchRefContainer: {
      display: 'flex',
      gap: theme.spacing(4),
      alignItems: 'center',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        gap: theme.spacing(2),
        flexDirection: 'column',
        alignItems: 'center',
      },
      [theme.breakpoints.down('xs')]: {
        alignItems: 'stretch',
        minWidth: '100%',
      },
    },
    loaderContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
    },
    searchRefInput: {
      display: 'flex',
      flexDirection: 'column',
      '& .paragraph-class': {
        margin: 0,
      },
    },
    searchRefInputSuccess: {},
    searchRefBtn: {
      marginBottom: `calc(${
        theme.typography.caption.fontSize
      }px + ${theme.spacing(1)}px)`,
    },
    referenceNumberError: {
      display: 'inline-flex',
      width: '100%',
      padding: theme.spacing(1, 2),
      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(1),
      },
    },
    selectContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(2),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        marginTop: theme.spacing(4),
      },
      [theme.breakpoints.down('md')]: {
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    formControl: {
      minWidth: 120,
      width: '100%',
    },
    referenceImage: {
      width: REF_IMG_D,
      [theme.breakpoints.down('md')]: {
        marginLeft: 'auto',
        marginRight: 'auto',
        margin: theme.spacing(4, 'auto', 0),
      },
    },
    imageSize: {
      width: '100%',
      objectFit: 'contain',
    },
    referenceImageTitle: {
      margin: theme.spacing(2, 0),
      textAlign: 'center',
    },
    label: {
      display: 'block',
      cursor: 'pointer',
      textAlign: 'inherit',
      marginBottom: theme.spacing(0.5),
      fontSize: 11,
      '& .paragraph-class': {
        margin: 0,
      },
    },
    labelAutoComplete: {
      display: 'block',
      cursor: 'pointer',
      textAlign: 'inherit',
      fontSize: 11,
      paddingLeft: theme.spacing(1.25),
      marginBottom: theme.spacing(0.5),
    },
    selector: {
      padding: theme.spacing(0.5, 2, 0.5, 1),
      height: 38,
      borderRadius: theme.shape.borderRadius,
      border: 'none',
      boxShadow: theme.shadows[1],
      fontSize: 12,
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
    },
    selectorPlaceholder: {
      color: theme.extraColors.greyMedium,
    },
    helpGrid: {
      alignItems: 'center',
    },
    helpLink: {
      justifyContent: 'start',
      padding: theme.spacing(0, 0, 0, 0.6),
      fontSize: theme.typography.caption.fontSize,
      textDecoration: 'underline',
      textTransform: 'inherit',
      color: theme.palette.common.black,
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(1),
      },
      '&:hover, &:focus': {
        background: 'none',
      },
    },
    states: {
      marginBottom: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      borderBottom: `1px solid ${theme.extraColors.greyLight}`,
      alignItems: 'center',
      '& .MuiFormControlLabel-label': {
        marginLeft: theme.spacing(2),
      },
    },
    statesForm: {},
    statesDefinitions: {
      color: theme.extraColors.greyText,
      marginLeft: theme.spacing(5),
    },
    marginBottom: {
      marginBottom: theme.spacing(2),
    },
    takeBackSecondStepContainer: {
      maxWidth: theme.breakpoints.width('md'),
      margin: 'auto',
    },
    takeBackSecondStep: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    productItem: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(2),
      gap: theme.spacing(7),
      [theme.breakpoints.down('md')]: {
        gap: theme.spacing(3),
      },
    },
    productName: {
      marginBottom: theme.spacing(1),
      paddingRight: theme.spacing(3),
    },
    productMeta: {
      marginBottom: theme.spacing(1),
    },
    productImage: {
      flex: `0 0 ${REF_IMG_M}px`,
    },
    productDetails: {
      position: 'relative',
      flex: 1,
      gap: theme.spacing(4),
      [theme.breakpoints.down('md')]: {
        gap: theme.spacing(2),
      },
    },
    productDescription: {},
    productPrice: {},
    productDelete: {
      padding: 0,
      minWidth: 0,
      position: 'absolute',
      top: 0,
      right: 0,
      '&:hover, &:focus': {
        background: 'none',
      },
    },
    productStatePrice: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    totalContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        gap: theme.spacing(1),
      },
    },
    totalPrice: {
      display: 'flex',
      alignItems: 'baseline',
      fontWeight: 700,
    },
    takeBackOffer: {
      '& p': {
        margin: 0,
      },
    },
    SecondStepButton: {
      alignSelf: 'center',
    },
    validAddress: {
      display: 'flex',
      justifyContent: 'center',
    },
    price: {
      fontWeight: 700,
    },
    locationContainer: {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        paddingTop: theme.spacing(6),
      },
    },
    locationTitleContainer: {
      marginBottom: theme.spacing(2),
    },
    locationTitle: {
      fontSize: theme.typography.h5.fontSize,
    },
    locationDesc: {
      '& p': {
        margin: 0,
      },
    },
    formLabelRow: {
      marginBottom: theme.spacing(1),
      '& .MuiFormControlLabel-root': {
        display: 'flex',
        gap: theme.spacing(1),
        margin: 0,
      },
      '& .paragraph-class': {
        margin: 0,
      },
    },
    location: {
      display: 'flex',
    },
    takeBackThirdStep: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 300,
      gap: theme.spacing(2),
      marginTop: theme.spacing(5),
    },
    confirmationIcon: {
      '&>svg': {
        fontSize: 60,
        color: theme.palette.success.main,
      },
    },
    confirmationText: {
      '&>h3': {
        marginTop: 0,
        fontSize: theme.typography.h3.fontSize,
      },
      padding: theme.spacing(3, 0, 3),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(2, 6, 2),
        maxWidth: theme.breakpoints.width('md'),
        textAlign: 'center',
      },
    },
    section: {
      padding: theme.spacing(0, 0, 3),
    },
    takeBackSecondStepSubmit: {
      padding: theme.spacing(1, 0, 0),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(6, 0, 4),
      },
    },
    myCustomHits: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 16,
      marginTop: 20,
    },
    myCustomHit: {
      flex: '1 1 calc(33.333% - 16px)',
      boxSizing: 'border-box',
      border: '1px solid #ddd',
      padding: 16,
      borderRadius: 8,
      textAlign: 'center',
      '&>img': {
        width: '100%',
        height: 'auto',
        maxWidth: 150,
        marginBottom: 8,
      },
    },
    itemLink: {
      display: 'flex',
      alignItems: 'center',
      padding: '10px',
      border: '1px solid #ddd',
      borderRadius: '8px',
      textDecoration: 'none',
      color: 'inherit',
      '&:hover': {
        backgroundColor: '#f0f0f0',
      },
    },
    itemRoot: {
      display: 'flex',
      flexDirection: 'row',
    },
    itemContent: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: '16px',
    },
    itemIcon: {
      '& img': {
        width: '50px',
        height: '50px',
        objectFit: 'cover',
        borderRadius: '4px',
      },
    },
    itemTitle: {
      fontSize: '16px',
      fontWeight: 'bold',
      marginBottom: '4px',
    },
    itemLabelReference: {
      fontSize: '11px',
      // fontWeight: 'bold',
      // marginBottom: '4px',
    },
    itemCategory: {
      fontSize: '14px',
      color: '#555',
    },
    input: {
      display: 'block',
      padding: theme.spacing(1, 1.25),
      fontFamily: theme.typography.fontFamily,
      width: '100%',
      fontSize: 14,
      borderRadius: theme.spacing(0.75),
      border: `1px solid ${theme.extraColors.greyLight}`,
      color: theme.typography.body1.color,
      backgroundColor: theme.extraColors.greyLight,
      WebkitAppearance: 'none',
      '&::placeholder': {
        opacity: 0.75,
        color: theme.typography.body1.color,
      },
      '&:disabled': {
        userSelect: 'none',
        cursor: 'not-allowed',
      },
      '& textarea': {
        fontFamily: theme.typography.fontFamily,
        color: theme.typography.body1.color,
        fontSize: 14,
      },
    },
    countrySelector: {
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(0.5, 2, 0.5, 1),
      backgroundColor: theme.extraColors.greyLight,
      minWidth: 200,
      color: theme.palette.common.black,
      height: 40,
      border: 'none',
    },
    parcelNumberContainer: {
      margin: '2rem auto',
      '& .label': {
        maxWidth: 'none',
        fontSize: '1.25rem',
        marginBottom: theme.spacing(2),
      },
    },
    parcelNumberButton: {
      marginTop: theme.spacing(3),
    },
  })
)

export default useStyles
